import axios from "axios";
import {Link, redirect, useLoaderData} from "react-router-dom";
import {Header} from "../layout/header.js";
import {Footer} from "../layout/footer.js";
import {BreadcrumbBar} from "../components/breadcrumbbar.js";
import {GenericBanner} from "../components/genericbanner.js";


/**
 * React-router-dom Loader function to load backend endpoint with
 * AJAX, the response from which drives the page.
 */
export async function loader() {
    try {
        const response = await axios.get(
            `/heliodata/app/load_datasetlist_page`
        );
        return {datasetListData: response.data};
    }
    catch (error) {
        return redirect("/error");
    }
}


/**
 * React component to display the dataset listing page.
 */
export function DatasetListPageContent() {
    const {datasetListData} = useLoaderData();

    return (
        <div>
          <Header />
          <GenericBanner
            title={"Dataset List"}
            tagline="Full list of available datasets in the Heliodata system."
          />

          <BreadcrumbBar
            levels={[
                {link: `/datasetlist/`, text: "Dataset List"},
            ]} />

          <div className="genericBody">
            <p>
              Total of {datasetListData.datasets.length} items.
            </p>

            <div className="genericBody">
              {datasetListData.datasets.map(dataset => {
                  return (
                      <div className="datasetListRowItem" key={dataset.hcutId}>
                        <Link to={`/dataset/${dataset.hcutId}`}>
                          {dataset.title}
                        </Link>
                      </div>
                  );
              })}
            </div>
          </div>
          <Footer />
        </div>
    );
}
